import React from 'react';
import {ToggleButton} from '~/common/fabric/CreateDesign/components/CardEditor/components/ToggleButton/ToggleButton';
import {charcoal, emerald} from '~libSass/base/_exports.sass';

import './TextFormatAlignmentBase.sass';

export const TextFormatAlignmentBase = ({icon, onClick, active, dataQaId}) => {
  const Icon = icon;

  return (
    <ToggleButton
      onChange={onClick}
      className={`text_format_base ${active ? 'text_format_base--checked' : ''}`}
      active={active}
      dataQaId={dataQaId}
    >
      <Icon width={16} height={14} color={active ? emerald : charcoal} />
    </ToggleButton>
  );
};
